export const Pool = Object.freeze({
    action: {
        offer: 'offer',
        delete: 'delete',
        restore: 'restore',
        quantity: 'quantity'
    }
});